var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDoc = function SvgDoc(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6C9 5.44772 8.55228 5 8 5C7.44772 5 7 5.44772 7 6V8.71412L6.34637 8.06709C5.95386 7.67855 5.32071 7.68177 4.93217 8.07427C4.54363 8.46677 4.54685 9.09993 4.93935 9.48846L7.29649 11.8218C7.68618 12.2075 8.31382 12.2075 8.70351 11.8218L11.0607 9.48846C11.4532 9.09993 11.4564 8.46677 11.0678 8.07427C10.6793 7.68177 10.0461 7.67855 9.65363 8.06709L9 8.71412V6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07143 0C3.3927 0 2.73975 0.266804 2.25675 0.744925C1.77341 1.22338 1.5 1.87449 1.5 2.55556V13.4444C1.5 14.1255 1.77341 14.7766 2.25675 15.2551C2.73975 15.7332 3.3927 16 4.07143 16H11.9286C12.6073 16 13.2602 15.7332 13.7432 15.2551C14.2266 14.7766 14.5 14.1255 14.5 13.4444V5.98845C14.4999 5.51375 14.3091 5.0605 13.9732 4.72798L9.71944 0.517202C9.38388 0.184986 8.93068 9.94802e-05 8.46043 0H4.07143ZM4.07143 2C3.91662 2 3.77017 2.06097 3.66377 2.1663C3.55771 2.27129 3.5 2.41151 3.5 2.55556V13.4444C3.5 13.5885 3.55771 13.7287 3.66377 13.8337C3.77017 13.939 3.91662 14 4.07143 14H11.9286C12.0834 14 12.2298 13.939 12.3362 13.8337C12.4423 13.7287 12.5 13.5885 12.5 13.4444V6.08386L8.37447 2H4.07143Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDoc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Doc.4b3eb140c6c2196abdc5ae83fb7230c4.svg";